import CheckIcon from '@mui/icons-material/Check'
import { Divider } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { arrayOf, bool, func, object, string } from 'prop-types'
import ReactJson from 'react18-json-view'
import { CvsTextField, CvsAlert } from '@components'
import { configOptions, qrCodeCustomizationOptions, integrationName } from '../config'
import { t } from '@lingui/core/macro'
import makeStyles from '@mui/styles/makeStyles'
import { Trans } from '@lingui/react/macro'

const useStyles = makeStyles(() => ({
  validateJsonBtn: {
    margin: '5px 0 10px 0',
  },
}))

export const ClassicConfig = props => {
  const {
    errors = [],
    handleChange,
    handleValidateConfigObject,
    jsonData,
    jsonValidated,
    showConfigOptions,
    validatingJson,
    value,
  } = props
  const { qrCodeConfig } = qrCodeCustomizationOptions
  const classes = useStyles()

  const text = (() => (
    <Trans>
      {integrationName}
      Configuration requires looking under the hood in&nbsp;
      <Link href="https://qrcode.studio" target="_blank" rel="noreferrer" underline="hover">
        {integrationName}
      </Link>
      &nbsp;for config JSON. We recommend working with your Claravine CSM to get this. This is used
      for additional customization and is not required.
    </Trans>
  ))()

  const hasErrors = errors.some(e => e)

  return (
    <Box mt={2}>
      <Box mb={1}>
        <CvsAlert>
          <Typography>{text}</Typography>
        </CvsAlert>
      </Box>
      <CvsTextField
        id={qrCodeConfig}
        label={t`${integrationName} Configuration`}
        onChange={e => handleChange(qrCodeConfig, e.target.value)}
        fullWidth
        error={hasErrors ? errors : ''}
        value={value || '{}'}
      />
      {showConfigOptions && (
        <Box mb={1}>
          <CvsAlert>
            <Typography>{t`Valid configuration properties`}</Typography>
            <Divider />
            {Object.keys(configOptions).map((key, i) => (
              <Typography key={key} variant="caption">
                {i !== Object.keys(configOptions).length - 1 ? `${key}, ` : key}
              </Typography>
            ))}
          </CvsAlert>
        </Box>
      )}
      <Button
        className={classes.validateJsonBtn}
        color={jsonValidated ? 'secondary' : 'primary'}
        disabled={validatingJson}
        startIcon={jsonValidated && <CheckIcon />}
        variant="outlined"
        onClick={() => handleValidateConfigObject()}
      >
        {t`Validate configuration`}
      </Button>
      <ReactJson name={false} displayDataTypes={false} displayObjectSize={false} src={jsonData} />
    </Box>
  )
}

ClassicConfig.propTypes = {
  errors: arrayOf(string),
  handleChange: func.isRequired,
  handleValidateConfigObject: func.isRequired,
  jsonData: object.isRequired,
  jsonValidated: bool.isRequired,
  showConfigOptions: bool.isRequired,
  validatingJson: bool.isRequired,
  value: string.isRequired,
}
